
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/text-mining/create",
      function () {
        return require("private-next-pages/text-mining/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/text-mining/create"])
      });
    }
  